import {
  Passenger,
  PassengerError,
  PassengerErrors,
  Passengers,
} from 'interfaces/booking';
import { validateInvoicePassengerInput } from './validation';

export const validateAllPassengers = (passengers: Passengers) => {
  // Loop through all the passengers and validate them
  const errors: PassengerErrors = {};

  (Object.keys(passengers) as (keyof Passengers)[]).forEach(type => {
    passengers[type].forEach((p, pIdx) => {
      // Loop through each passenger's key and validate the key values
      let error = {} as PassengerError;
      (Object.keys(p) as (keyof Passenger)[]).map(key => {
        let tmpError: PassengerError = validateInvoicePassengerInput(
          p,
          key,
          type,
        );
        // If validation error was found, append it to the object
        if (tmpError[key] !== '') {
          error = { ...error, ...tmpError };
        }
      });

      // validate document
      // TODO: make document validation

      // If every field is validated correctly, not appending anything to the final passengerErrors object
      // This will come in handy later on when checking for validation error status on the cart page
      if (Object.keys(error).length > 0) {
        errors[`${type}/${pIdx}`] = error;
      }
    });
  });

  return errors;
};

export const validatePassengerInput = (
  payload: { key: keyof Passenger; p: Passenger; id?: string; value?: any },
  passengerErrors: PassengerErrors | undefined,
) => {
  // Validates one passenger input or one invoice input by the given key
  // For example validates an input for "adults/0" (for the first adult) etc...
  // Id is the following format: "adults/0" or "adults/1" or "children/0", etc...
  const { p, key, id, value } = payload;
  let error = {} as PassengerError;
  let splittedType = '';
  const errors: PassengerErrors = { ...passengerErrors };

  if (!id || !errors) return null;
  // Preparing the initial errors with spread operator to load the previous errors
  splittedType = id.split('/')[0];
  error = { ...errors[id] } as PassengerError;

  // Retruns validation error for one field
  const errorMessages = validateInvoicePassengerInput(p, key, splittedType);
  // Handling birthDate validations
  if ('birthDate' in errorMessages && errorMessages['birthDate'] !== '') {
    error = { ...error, ...errorMessages };
  } else {
    delete error['birthDate'];
  }
  // If validation error was found, append it to the object else remove it
  if (errorMessages[key] !== '') {
    error = { ...error, ...errorMessages };
  } else {
    delete error[key];
  }

  // Handling countryCode:
  // This solves the following issue: When a validation error occurs at the countryCode and the user
  // selects a valid country (passengerValidation() is called), the error message didn't dissapear on the first country select click, only on the second select
  // because of the synchronousness of the redux state management.
  // So to solve this the value is passed from the onBlur() event on PassengerDetails and the countryCode field in the error object is set to empty string
  if (key === 'countryCode' && value && value !== '') {
    delete error["countryCode"];
  }
  if (key === 'documentCountry' && value && value !== '') {
    delete error["documentCountry"];
  }

  // If every field is validated correctly, not appending anything to the final passengerErrors object
  if (id) {
    // Setting the passenger validation errors for the correct passenger (id)
    if (Object.keys(error).length > 0) {
      errors[id] = error;
    } else {
      delete errors[id]
    }
  }

  // return all errors
  return errors;
};

export const validateInvoiceInput = (
  payload: { key: keyof Passenger; p: Passenger; id?: string; value?: any },
  invoiceDataError: PassengerError | null
) => {
  const { p, key, id, value } = payload;
  if (!invoiceDataError) return null;
  let splittedType = '';

  let error = { ...invoiceDataError }
  // Retruns validation error for one field
  const errorMessages = validateInvoicePassengerInput(p, key, splittedType);
  // Handling birthDate validations
  if ('birthDate' in errorMessages && errorMessages['birthDate'] !== '') {
    error = { ...error, ...errorMessages };
  } else {
    delete error['birthDate'];
  }
  // If validation error was found, append it to the object else remove it
  if (errorMessages[key] !== '') {
    error = { ...error, ...errorMessages };
  } else {
    delete error[key];
  }

  // Handling countryCode:
  // This solves the following issue: When a validation error occurs at the countryCode and the user
  // selects a valid country (passengerValidation() is called), the error message didn't dissapear on the first country select click, only on the second select
  // because of the synchronousness of the redux state management.
  // So to solve this the value is passed from the onBlur() event on PassengerDetails and the countryCode field in the error object is set to empty string
  if (key === 'countryCode' && value && value !== '') {
    delete error["countryCode"];
  }

  return error;
}
